package com.xtream.ui.tv.presentation.common

 import androidx.compose.animation.Crossfade
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.Image
import androidx.compose.foundation.focusGroup
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredSize
import androidx.compose.foundation.layout.wrapContentWidth
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Star
import androidx.compose.material.icons.outlined.AccessTime
import androidx.compose.material.icons.outlined.BookmarkAdd
import androidx.compose.material.icons.outlined.DateRange
import androidx.compose.material.icons.outlined.PlayCircle
import androidx.compose.material.icons.rounded.PlayArrow
import androidx.compose.material3.BottomSheetScaffold
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SheetValue
import androidx.compose.material3.Text
import androidx.compose.material3.rememberBottomSheetScaffoldState
import androidx.compose.material3.rememberStandardBottomSheetState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.focus.FocusDirection
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.focusRestorer
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.CompositingStrategy
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.platform.LocalLayoutDirection
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.LayoutDirection
import androidx.compose.ui.unit.dp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import coil3.compose.AsyncImagePainter
import coil3.compose.rememberConstraintsSizeResolver
import com.xtream.composeapp.platform.PlatformType
import com.xtream.composeapp.platform.currentPlatform
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.add_to_favorites
import com.xtream.sharedResources.resources.play
import com.xtream.sharedResources.resources.trailer
import com.xtream.ui.ui.widget.TvBaseButton
import com.xtream.ui.ui.widget.XAssistChip
import com.xtream.ui.ui.widget.rememberPlatformImagePainter
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource

@Composable
fun Modifier.blendBorders()= drawWithContent {

        drawContent()

        // Horizontal Fade (Left & Right)
        drawRect(
            brush = Brush.horizontalGradient(
                listOf(
                    Color.Transparent,
                    Color.Black.copy(alpha = .5f),
                    Color.Black,
                    Color.Black,
                    Color.Black,
                    Color.Transparent)
            ),
            blendMode = BlendMode.DstIn
        )

        // Vertical Fade (Top & Bottom)
        drawRect(
            brush = Brush.verticalGradient(
                listOf(Color.Transparent, Color.Black,Color.Black, Color.Black, Color.Transparent)
            ),
            blendMode = BlendMode.DstIn
        )
    }

@Composable
fun TvBaseInfoLayout(
    backDropPainter: Painter,
    modifier: Modifier = Modifier,
    onMainButtonClick: () -> Unit = {},
    @OptIn(ExperimentalMaterial3Api::class)
    onSheetStateChange : (SheetValue)->Unit={},
    backLayerContent: @Composable () -> Unit = {},
    frontLayerContent: @Composable () -> Unit = {}


){

    val scope = rememberCoroutineScope()
    @OptIn(ExperimentalMaterial3Api::class)
    val bottomSheetState = rememberStandardBottomSheetState(initialValue = SheetValue.PartiallyExpanded)
    @OptIn(ExperimentalMaterial3Api::class)
    val scaffoldState =
        rememberBottomSheetScaffoldState(bottomSheetState)
    val frontLayerFocusRequester = remember { FocusRequester() }
    val backLayerFocusRequester = remember { FocusRequester() }
    var backLayerFocusable by remember { mutableStateOf(false) }

    val focusManager = LocalFocusManager.current
    // Restore focus when screen is (re)entered
/*    LaunchedEffect(Unit) {
       if(!backLayerFocusRequester.restoreFocusedChild()) {
           if (!frontLayerFocusRequester.restoreFocusedChild()) {
                backLayerFocusRequester.requestFocus()
           }
       }
    }*/

    Box(){
        AnimatedBackdropImage(
            painter = backDropPainter,
            modifier = Modifier
                .align(Alignment.TopEnd)
                .fillMaxSize(.7f)
                .aspectRatio(16f / 9f)
        )

        val bottomSheetPeekHeight = 100.dp
        val density = LocalDensity.current
        val windowHeightPx = LocalWindowInfo.current.containerSize.height

        val backLayerHeight = with(density) { windowHeightPx.toDp() - bottomSheetPeekHeight }

        @OptIn(ExperimentalMaterial3Api::class)
        BottomSheetScaffold(
            modifier = Modifier,
            sheetMaxWidth = Dp.Unspecified,
            sheetDragHandle = null,

            // backgroundColor = Color.Transparent,
            sheetContainerColor = MaterialTheme.colorScheme.background,
            sheetPeekHeight = bottomSheetPeekHeight,
            sheetShape = RectangleShape, // Removes corner radius
            sheetSwipeEnabled = false,
            sheetShadowElevation = 0.dp,
            //frontLayerScrimColor = Color.Transparent,
            scaffoldState = scaffoldState,
            //  persistentAppBar = false,
            content = {
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(backLayerHeight)

                        .focusRequester(backLayerFocusRequester)
                        //.focusable(backLayerFocusable)
                ) {
                    backLayerContent()
                }
            },
            sheetContent = {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .onKeyEvent { keyEvent ->
                            // 1. Extract platform-agnostic Key and EventType representations
                            val currentKey = keyEvent.key
                            //note web only supports key up
                            val enable = keyEvent.type ==KeyEventType.KeyDown || (currentPlatform == PlatformType.WEB && keyEvent.type ==KeyEventType.KeyUp)
                            if (enable) {
                                when (currentKey) {
                                    // 2. 🚀 Key.DirectionUp automatically catches Android's KEYCODE_DPAD_UP
                                    // AND standard Desktop/PC Keyboard Up arrow keys!
                                    Key.DirectionUp -> {

                                        val moveInsideParent = focusManager.moveFocus(FocusDirection.Up)

                                        if (!moveInsideParent) {
                                            backLayerFocusRequester.requestFocus()
                                        }
                                        true // Key consumed
                                    }

                                    else -> false // Pass other keys down the focus hierarchy
                                }
                            } else {
                                false
                            }}
                        .focusRequester(frontLayerFocusRequester)
                        .focusGroup()


                        .focusProperties {

                            onEnter = {
                                backLayerFocusable = true
                                scope.launch { bottomSheetState.expand() }
                            }
                            onExit = {

                                scope.launch {
                                    bottomSheetState.partialExpand()
                                    backLayerFocusable = false

                                }

                            }

                        }
                ) { frontLayerContent() }
            },
            // appBar = {}

        )




    }

    @OptIn(ExperimentalMaterial3Api::class)

    LaunchedEffect(bottomSheetState) {
        onSheetStateChange.invoke( bottomSheetState.currentValue)
    }

}

@Composable
fun AnimatedBackdropImage(
    painter: Painter,
    modifier: Modifier = Modifier,
    contentDescription: String? = null,
) {
    val isRtl = LocalLayoutDirection.current == LayoutDirection.Rtl

    var visible by remember { mutableStateOf(false) }
    val animatedOffsetX by animateFloatAsState(
        targetValue = if (visible) 0f else if (isRtl) -50f else 50f,
        animationSpec = tween(durationMillis = 500, easing = LinearEasing),
        label = "backdropSlideX"
    )

    LaunchedEffect(Unit) {
        visible = true
    }

    Image(
        painter = painter,
        contentDescription = contentDescription,
        modifier = modifier
            .graphicsLayer(
                compositingStrategy = CompositingStrategy.Offscreen,
                translationX = animatedOffsetX
            )
            .drawWithContent {
                drawContent()
                drawRect(
                    brush = Brush.horizontalGradient(
                        listOf(
                            Color.Transparent,
                            Color.Black.copy(alpha = .5f),
                            Color.Black,
                            Color.Black,
                            Color.Black,
                            Color.Transparent
                        )
                    ),
                    blendMode = BlendMode.DstIn
                )
                drawRect(
                    brush = Brush.verticalGradient(
                        listOf(Color.Transparent, Color.Black, Color.Black, Color.Black, Color.Transparent)
                    ),
                    blendMode = BlendMode.DstIn
                )
            },
        alignment = Alignment.Center,
        contentScale = ContentScale.Crop
    )
}
@Composable
fun TvInfoComposeLayout(
    modifier: Modifier = Modifier,
    title: String? = null,
    logoTitle: String? = null,
    rating: String? = null,
    genre: String? = null,
    plot: String? = null,
    releaseDate: String? = null,
    duration: String? = null,
    onMainButtonClick: (() -> Unit)? = null,
    secondaryButtonTitle: String? = stringResource(Res.string.add_to_favorites),
    secondaryButtonIcon: ImageVector = Icons.Outlined.BookmarkAdd,
    onSecondaryButtonClick: () -> Unit = {},
    tertiaryButtonEnabled: Boolean = false,
    tertiaryButtonTitle: String? = stringResource(Res.string.trailer),
    tertiaryButtonIcon: ImageVector = Icons.Outlined.PlayCircle,
    tertiaryButtonClick: () -> Unit = {},
    showButtons: Boolean=true,
    verticalArrangement: Arrangement.Vertical = Arrangement.Bottom


){

    var titleLogoFailed by remember {  mutableStateOf(false) }
    val rowFocusRequester = remember { FocusRequester() }
    val defaultContentFocusRequester = remember { FocusRequester() }

    Column(
        modifier = modifier
            //.padding(horizontal = 48.dp)
            .fillMaxSize(), // Column fills the maximum available size
        verticalArrangement = verticalArrangement, // Aligns children to the bottom
        horizontalAlignment = Alignment.Start // Centers children horizontally

    ) {


        Crossfade(
            modifier =  Modifier
                .fillMaxWidth(.5f)
                .padding(
                    start = 6.dp,
                    end = 6.dp,
                    top = 6.dp,
                    bottom = 8.dp
                ),
            targetState = logoTitle!=null) { showLogoTitle->
            if (showLogoTitle && !titleLogoFailed) {
                val sizeResolver = rememberConstraintsSizeResolver()
                val painter = rememberPlatformImagePainter(logoTitle, sizeResolver)
                val state by painter.state.collectAsStateWithLifecycle()

                Image(
                    painter = painter,
                    contentDescription = title,
                    contentScale = ContentScale.Inside,
                    modifier = Modifier
                        .fillMaxWidth(0.5f)
                        .height(100.dp)
                        .then(sizeResolver) // ← attaches the size measurement
                )

                LaunchedEffect(state) {
                     if (state is AsyncImagePainter.State.Error) {
                        titleLogoFailed = true
                    }
                }
            }else{


                Text(
                    text = title ?: "",
                    color = MaterialTheme.colorScheme.onBackground,
                    textAlign = TextAlign.Start,
                    // Keep horizontal and top padding
                    //fontSize = 24.sp,
                    style = MaterialTheme.typography.titleLarge,
                    maxLines = 1,
                    fontWeight = FontWeight.Bold,
                    overflow = TextOverflow.Ellipsis
                )
            }

        }
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(bottom = 12.dp),

            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (genre != null)
                XAssistChip(title=genre,  borderEnabled = true)

            XAssistChip(title=rating,vectorIcon =  rememberVectorPainter(Icons.Default.Star), borderEnabled = true, tint =  MaterialTheme.colorScheme.primary)
            XAssistChip(title=duration, vectorIcon =  rememberVectorPainter(Icons.Outlined.AccessTime))


            XAssistChip(title=releaseDate, vectorIcon = rememberVectorPainter(Icons.Outlined.DateRange), borderEnabled = true)

        }
        Text(
            text = plot ?: "",
            color = MaterialTheme.colorScheme.onBackground,
            textAlign = TextAlign.Start,
            modifier = Modifier
                .fillMaxWidth(.5f)
                .padding(
                    start = 6.dp,
                    end = 6.dp,
                    top = 6.dp,
                    bottom = 8.dp
                ), // Keep horizontal and top padding
            //fontSize = 24.sp,
            style = MaterialTheme.typography.bodyMedium,
            maxLines = 3,
            overflow = TextOverflow.Ellipsis
        )


        if(showButtons)
        Row(
            modifier = Modifier
                .wrapContentWidth()

                .focusRequester(rowFocusRequester)
                .focusRestorer(defaultContentFocusRequester)
                .focusGroup()
                .padding(top = 12.dp),

            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if(onMainButtonClick!=null)
                TvBaseButton (
                    onClick = {
                        onMainButtonClick.invoke()
                    },
                    title = stringResource(Res.string.play),
                    startContent = {
                        Icon(
                            imageVector = Icons.Rounded.PlayArrow,
                            contentDescription =stringResource(Res.string.play),
                            modifier = Modifier.requiredSize(20.dp)
                        )
                    },
                    modifier = Modifier
                        .focusRequester(defaultContentFocusRequester)
                        .height(58.dp),
                    /*colors = ButtonDefaults.buttonColors(
                    )*/
                )
            TvBaseButton (
                onClick = {
                    onSecondaryButtonClick.invoke()
                },
                title = secondaryButtonTitle?:"",
                startContent = {
                    Icon(
                        imageVector = secondaryButtonIcon,
                        contentDescription = "Play",
                        modifier = Modifier.requiredSize(20.dp)
                    )
                },
                modifier = Modifier
                    .height(58.dp),
                /*colors = ButtonDefaults.buttonColors(
                )*/
            )
            if(tertiaryButtonEnabled)
                TvBaseButton (
                    onClick = {
                        tertiaryButtonClick.invoke()
                    },
                    title = tertiaryButtonTitle?:"",
                    startContent = {
                        Icon(
                            imageVector = tertiaryButtonIcon,
                            contentDescription = tertiaryButtonTitle,
                            modifier = Modifier.requiredSize(20.dp)
                        )
                    },
                    modifier = Modifier
                        .height(58.dp),
                    /*colors = ButtonDefaults.buttonColors(
                    )*/
                )
        }










    }


}